/** 
 * DASHBOARD-QUESTIONS-NOTE.WIDGET
 * Display note for a topic
 */

import { connect } from "react-redux"
import { Topic } from "@/redux/topic.types";
import { Session } from "@/redux/_session.types";
import { useCountUp } from "@/utils/use-count-up.utils"

interface StateProps{
  _session : Session
}

interface OwnProps{
  currentTopic : Topic
}

type Props = StateProps & OwnProps

//Réplique topic.noteLabel (redux/topic.types.ts) pour la valeur animée
function formatNoteLabel(note: number): string {
  if (!note) return "-"
  if (note >= 100) return "10."
  return (note / 10).toFixed(1)
}

function DashboardQuestionsNoteWidget(props:Props) {
  const animatedNote = useCountUp(props.currentTopic.note ?? 0)
  const animatedSatisfaction = useCountUp(props.currentTopic.satisfaction ?? 0)

  return (
    <div style={{ color : props.currentTopic.Axis?.color }}
      className="details-topic-note">
      <b>
        { props.currentTopic.withScore
        ?
        (
          props._session.dashboardDisplaySettings.dashboardDisplayMode === "note"
          ?
          formatNoteLabel(animatedNote)
          :
          animatedSatisfaction.toFixed(0) + "%"
        )
        :
        null
        }
      </b>
    </div>
  )

}

const mapStateToProps = state => ({
  _session : state._session
})

export default connect(mapStateToProps)(DashboardQuestionsNoteWidget)